import { useQuery } from "@tanstack/react-query";

import { getValidationRun } from "services";

import { GET_VALIDATION_RUN, POLL_TIMEOUT_MS } from "consts";

export const useValidationRun = (runId: string | null, startedAt: number | null) =>
  useQuery({
    queryKey: [GET_VALIDATION_RUN, runId],
    queryFn: () => getValidationRun(runId!),
    enabled: !!runId,
    refetchInterval: (query) => {
      const { status } = query.state.data ?? {};
      if (status === "completed" || status === "failed") return false;
      if (startedAt && Date.now() - startedAt > POLL_TIMEOUT_MS) return false;
      return 5000;
    },
    staleTime: Infinity,
    retry: false,
  });
